export const GET_SIMCARD_REQUEST = 'GET_SIMCARD_REQUEST';
export const GET_SIMCARD_SUCCESS = 'GET_SIMCARD_SUCCESS';
export const GET_SIMCARD_FAILURE = 'GET_SIMCARD_FAILURE';

export const SET_SIMCARD = 'SET_SIMCARD';

export const getSimcardRequest = (filters = {}) => ({
    type: GET_SIMCARD_REQUEST,
    payload: {
        filters
    }
});

export const getSimcardSuccess = (simcard) => ({
    type: GET_SIMCARD_SUCCESS,
    payload: {
        simcard
    }
});

export const getSimcardFailure = err => ({
    type: GET_SIMCARD_FAILURE,
    error: err
});

export const setSimcard = (simcard = {}) => ({
    type: SET_SIMCARD,
    payload: {
        simcard
    }
});
